import React, { useState } from 'react';
import { Container, Card, Button, Alert } from 'react-bootstrap';
import DynamicForm from '../Import/DynamicForm';

const DynamicFormTest = () => {
  const [showAnalysis, setShowAnalysis] = useState(false);
  // Test data that mimics the extracted JSON structure
  const testData = {
    "case": {
      "case_information": {
        "Case UPC": "000 42238 85275 4",
        "Product Type": "Case"
      }
    },
    "products": [
      {
        "product_id": "1",
        "name": "Goldbears",
        "product_information": {
          "Retail Pkg. UPC": "0 42238 30241 9",
          "Country of Origin": "Germany",
          "Retail Pkg. Dimension (L/DxWxH)": "7.9\" x 5.7\" x 0.5\"",
          "Shelf Life": "24 months",
          "Retail Pkg. Net Wt.": "4oz (113g)",
          "Product Type": "Each"
        },
        "physical_chemical_attributes": {
          "pH": "6.5 - 7.0",
          "Moisture": "< 12%",
          "Color": "Golden"
        }
      },
      {
        "product_id": "2",
        "name": "Twin Snakes",
        "product_information": {
          "Retail Pkg. UPC": "0 42238 34093 0",
          "Country of Origin": "Turkey",
          "Retail Pkg. Dimension (L/DxWxH)": "7.9\" x 5.7\" x 0.5\"",
          "Shelf Life": "24 months",
          "Product Type": "Each"
        },
        "physical_chemical_attributes": {
          "pH": "5.8 - 6.2",
          "Moisture": "< 10%",
          "Texture": "Chewy"
        }
      }
    ]
  };

  // Mock props that would normally come from the upload process
  const mockProps = {
    bucketName: "test-bucket",
    objectName: "test-file.pdf",
    email: "test@example.com",
    thumbnails: ["test-file.pdf.png"],
    apiUrl: "http://localhost:5000",
    testData: testData
  };

  // Function to analyze the test data structure
  const analyzeTestData = () => {
    console.log('=== TEST DATA ANALYSIS ===');
    testData.products.forEach((product, index) => {
      console.log(`\nProduct ${index + 1}: ${product.name}`);
      console.log('Product Information Fields:');
      Object.entries(product.product_information || {}).forEach(([fieldName, fieldValue]) => {
        console.log(`  - "${fieldName}": "${fieldValue}"`);
        if (fieldName === "Country of Origin") {
          console.log(`    *** COUNTRY OF ORIGIN FOUND! ***`);
        }
      });
    });
    setShowAnalysis(true);
  };

  return (
    <Container className="mt-4">
      <Card>
        <Card.Header>
          <h4>DynamicForm Test - Country of Origin Debug</h4>
        </Card.Header>
        <Card.Body>
          <p>This test loads the DynamicForm component with mock data to debug the Country of Origin field issue.</p>
          <p><strong>Check the browser console for debug output.</strong></p>

          <Button onClick={analyzeTestData} className="mb-3">
            Analyze Test Data in Console
          </Button>

          {showAnalysis && (
            <Alert variant="success">
              <h6>Test Data Analysis Complete!</h6>
              <p>Check the browser console for detailed analysis. The test data includes:</p>
              <ul>
                <li><strong>Product 1 (Goldbears):</strong> Country of Origin = "Germany"</li>
                <li><strong>Product 2 (Twin Snakes):</strong> Country of Origin = "Turkey"</li>
              </ul>
              <p>If these fields don't appear in the product tabs below, there's an issue with the field processing.</p>
            </Alert>
          )}

          <div className="alert alert-info">
            <h6>What to look for in the console:</h6>
            <ul>
              <li>🔍 COUNTRY OF ORIGIN FOUND IN PROCESSED DATA!</li>
              <li>🔍 RENDERING COUNTRY OF ORIGIN FIELD:</li>
              <li>🔍 CATEGORIZING FIELD WITH COUNTRY/ORIGIN:</li>
              <li>🔍 RENDERING PRODUCT X FIELDS:</li>
              <li>Field reorganization logs</li>
            </ul>
          </div>
        </Card.Body>
      </Card>
      
      <div className="mt-4">
        <DynamicForm {...mockProps} />
      </div>
    </Container>
  );
};

export default DynamicFormTest;
